export const title = state => state.title
export const subTitle = state => state.subTitle
export const subTitles = state => state.subTitles
export const backgroundClass = state => state.backgroundClass
